
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"importLoaders\":1}!../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-949f0f7a\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./LumiApp.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"presets\":[\"latest\"]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./LumiApp.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-949f0f7a\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!./LumiApp.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./components/LumiApp.vue
// module id = 4
// module chunks = 0